import useSWR from 'swr';

import { AIConversationMessages, AIMessage } from '@/api/ai-search';
import { ENDPOINTS } from '@/api/endpoints';

export const useMessages = (conversationId?: string) => {
  const key = conversationId ? [ENDPOINTS.AI_SEARCH_MESSAGES, conversationId] : undefined;

  const { data, isLoading, mutate, isValidating } = useSWR<AIMessage[]>(
    key,
    () => (conversationId ? AIConversationMessages(conversationId) : Promise.resolve([])),
    { revalidateOnFocus: false }
  );

  return {
    messages: data ?? [],
    loading: isLoading,
    validating: isValidating,
    refetchMessages: mutate,
  };
};
